import { useEffect, useState } from "react";

export function useMediaQuery(query: string) {
    
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);

        const update = () => setMatches(media.matches);

        update(); // set initial value
        media.addEventListener("change", update);

        return () => media.removeEventListener("change", update);
    }, [query]);

    return matches;
}